module.exports = __webpack_public_path__ + "static/img/prize.3fdda2b5.svg";